export default {
  cardTab: (state) => state.cardTab,
  mobile: (state) => state.userAgent.device.type === 'mobile',
  transcoderSize: (state) => ({
    pixels: state.transcoderSize,
    name: (() => {
      if (state.transcoderSize < 500) return 'xs';
      else if (state.transcoderSize < 600) return 'sm';
      else if (state.transcoderSize < 800) return 'md';
      else if (state.transcoderSize < 1000) return 'lg';
      return 'xl';
    })(),
  }),
  compact: (state, getters) => ['xs', 'sm'].includes(getters.transcoderSize.name),
};